// Функція для обчислення часу до повторної доступності квесту (обчислюється один раз під час рендерингу)
export const calculateTimeUntilAvailable = (questId: number): string => {
  const now = new Date();
  
  if (questId === 41) {
    // Час до наступної години (хвилини = 00)
    const nextHour = new Date(now);
    nextHour.setHours(now.getHours() + 1, 0, 0, 0);
    const diff = nextHour.getTime() - now.getTime();
    
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    const parts: string[] = [];
    if (hours > 0) {
      parts.push(`${hours} ${hours !== 1 ? 'hours' : 'hour'}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes} ${minutes !== 1 ? 'minutes' : 'minute'}`);
    }
    if (seconds > 0 || parts.length === 0) {
      parts.push(`${seconds} ${seconds !== 1 ? 'seconds' : 'second'}`);
    }
    
    return parts.join(' ');
  } else {
    // Час до опівночі UTC
    const nextMidnight = new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() + 1,
      0, 0, 0, 0
    ));
    
    const diff = nextMidnight.getTime() - now.getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    const parts: string[] = [];
    if (hours > 0) {
      parts.push(`${hours} ${hours !== 1 ? 'hours' : 'hour'}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes} ${minutes !== 1 ? 'minutes' : 'minute'}`);
    }
    if (seconds > 0 || parts.length === 0) {
      parts.push(`${seconds} ${seconds !== 1 ? 'seconds' : 'second'}`);
    }
    
    return parts.join(' ');
  }
};
